import React, { useContext, useEffect, useState } from "react";
import "./ContactUs.css";
import "./ResponsiveContactUs.css";
import wallpaper from "../../assets/images/contactUs.png";
import { Dropdown, Form } from "react-bootstrap";
import { dataContext } from "../../context/DataContextProviderr";
import { filterKey } from "../../helper/function";
import ScrollAnimation from "react-animate-on-scroll";
import LoadingPage from "../../components/loadingPage/LoadingPage";
const ContactUs = () => {
  const { allWebParts, isLoading } = useContext(dataContext);
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    productType: "",
    messageType: "",
    message: "",
  });
  const productTypes = ["خبازی", "صنعتی", "قنادی", "دامپروری", "خوراک دام"];
  const messageTypes = ["شکایت", "پیشنهاد", "انتقاد"];
  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };
  const handleDropdownChange = (field, value) => {
    setFormData({
      ...formData,
      [field]: value,
    });
  };

  const filterContactUs = allWebParts?.filter(
    (x) => x.uniqueName === "contactUs",
  );

  const filterFooter = allWebParts?.filter(
    (x) => x.uniqueName === "footer-homePage",
  );

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, []);

  const submitHandler = (e) => {
    e.preventDefault();
    console.log("Form Data:", formData);
    setFormData({
      name: "",
      phone: "",
      productType: "",
      messageType: "",
      message: "",
    });
  };

  return (
    <>
      {isLoading ? (
        <LoadingPage />
      ) : (
        <div className="contact-us">
          <div
            className="wallpaper"
            style={{ backgroundImage: `url(${wallpaper})` }}
          >
            <div className="text">
              <p>
                {filterKey(filterContactUs, "title-part1")?.map(
                  (item) => item.Value,
                )}{" "}
                <span>
                  {filterKey(filterContactUs, "title-part2")?.map(
                    (item) => item.Value,
                  )}
                </span>
              </p>
              <img src="/pic/cloud.png" alt="cloud" />
            </div>
          </div>
          <div className="contactus-detail">
            <ScrollAnimation
              // animateIn="bounceIn"
              animateIn="rotateInUpLeft"
              // animateIn="zoomIn"
              delay={400}
              className="box"
            >
              <img src="/pic/call.png" alt="call-icon" />
              <p>فروش و پیگیری حمل</p>
              <span>
                {filterKey(filterContactUs, "qc-tell-1")?.map(
                  (item) => item.Value,
                )}
              </span>
              <p>شکایت مشتری</p>
              <span>
                {filterKey(filterContactUs, "qc-tell-2")?.map(
                  (item) => item.Value,
                )}
              </span>
              <p>فروش</p>
              <span>
                {filterKey(filterContactUs, "sale")?.map((item) => item.Value)}
              </span>
              <p>سامانه پیگیری شکایات مشتریان </p>
              <a
                target="_blank"
                rel="noreferrer"
                href={filterKey(filterContactUs, "crmAddress")?.map(
                  (item) => item.Value,
                )}
              >
                {filterKey(filterContactUs, "crmAddress")?.map(
                  (item) => item.Value,
                )}
              </a>
            </ScrollAnimation>
            <ScrollAnimation
              // animateIn="bounceIn"
              animateIn="slideInUp"
              // animateIn="zoomIn"
              delay={400}
              className="box box-center"
            >
              <img src="/pic/location.png" alt="location-icon" />
              <p>دفتر مرکزی</p>
              <span>
                {filterKey(filterContactUs, "centeral-office-address")?.map(
                  (item) => item.Value,
                )}
              </span>
              <p>کارخانه</p>
              <span>
                {filterKey(filterContactUs, "factory-address")?.map(
                  (item) => item.Value,
                )}
              </span>
            </ScrollAnimation>
            <ScrollAnimation
              // animateIn="bounceIn"
              animateIn="rotateInUpRight"
              // animateIn="zoomIn"
              delay={400}
              className="box"
            >
              <img src="/pic/call.png" alt="call-icon" />
              <p>دفتر مرکزی</p>
              <span>
                {filterKey(filterContactUs, "central-office-tell-1")?.map(
                  (item) => item.Value,
                )}
              </span>
              <span>
                {filterKey(filterContactUs, "central-office-tell-2")?.map(
                  (item) => item.Value,
                )}
              </span>
              <span>
                {filterKey(filterContactUs, "central-office-tell-3")?.map(
                  (item) => item.Value,
                )}
              </span>
              <span>
                {filterKey(filterContactUs, "central-office-tell-4")?.map(
                  (item) => item.Value,
                )}
              </span>
              <p>سامانه پیامکی ارتباط با مشتریان </p>
              <span>
                {filterKey(filterContactUs, "central-office-tell-6")?.map(
                  (item) => item.Value,
                )}
              </span>
            </ScrollAnimation>
            <ScrollAnimation
              // animateIn="bounceIn"
              animateIn="slideInUp"
              // animateIn="zoomIn"
              delay={400}
              className="box box-center mobile"
            >
              <img src="/pic/location.png" alt="location-icon" />
              <p>دفتر مرکزی</p>
              <span>
                {filterKey(filterContactUs, "centeral-office-address")?.map(
                  (item) => item.Value,
                )}
              </span>
              <p>کارخانه</p>
              <span>
                {filterKey(filterContactUs, "factory-address")?.map(
                  (item) => item.Value,
                )}
              </span>
            </ScrollAnimation>
          </div>

          <div className="form-container">
            <div className="top">
              <p className="p1">
                {" "}
                نظرات و پیشنهادات خود را <span>با ما</span> به اشتراک بگذارید
              </p>
            </div>
            <Form className="form" onSubmit={submitHandler}>
              <div className="row">
                <Form.Control
                  type="text"
                  placeholder="نام و نام خانوادگی "
                  name="name"
                  onChange={handleChange}
                  value={formData.name}
                />
                <Form.Control
                  onChange={handleChange}
                  value={formData.phone}
                  type="tel"
                  name="phone"
                  placeholder="شماره موبایل"
                  maxLength={11}
                  minLength={11}
                  className="text-end"
                />
              </div>
              <div className="row">
                <Dropdown className="items">
                  <Dropdown.Toggle className="d-flex justify-content-between align-items-center">
                    {formData.productType ? formData.productType : "نوع محصول"}
                  </Dropdown.Toggle>

                  <Dropdown.Menu>
                    {productTypes.map((type, index) => (
                      <Dropdown.Item
                        key={index}
                        onClick={() =>
                          handleDropdownChange("productType", type)
                        }
                      >
                        {type}
                      </Dropdown.Item>
                    ))}
                  </Dropdown.Menu>
                </Dropdown>

                <Dropdown className="items">
                  <Dropdown.Toggle className="d-flex justify-content-between align-items-center">
                    {formData.messageType
                      ? formData.messageType
                      : "نوع پیام ارسالی"}
                  </Dropdown.Toggle>

                  <Dropdown.Menu>
                    {messageTypes.map((type, index) => (
                      <Dropdown.Item
                        key={index}
                        onClick={() =>
                          handleDropdownChange("messageType", type)
                        }
                      >
                        {type}
                      </Dropdown.Item>
                    ))}
                  </Dropdown.Menu>
                </Dropdown>
              </div>

              <div className="textarea-container">
                <Form.Control
                  as="textarea"
                  rows={3}
                  placeholder="لطفا پیام خود را تایپ کنید"
                  onChange={handleChange}
                  name="message"
                  value={formData.message}
                />
              </div>

              <div className="button-container">
                <button type="submit"> ارسال پیام</button>
              </div>
            </Form>
          </div>

          <ScrollAnimation
            // animateIn="bounceIn"
            // animateIn="slideInUp"
            animateIn="zoomIn"
            delay={400}
            v
            className="shop-container"
          >
            <div className="shop">
              <div className="content">
                <p>سامانه خرید آرد</p>
                <a
                  href={filterKey(filterFooter, "purchase-flour-link")?.map(
                    (item) => item.Value,
                  )}
                  target="_blank"
                  rel="noreferrer"
                >
                  Gfloursale.Banksepah.Ir
                </a>
              </div>
            </div>
          </ScrollAnimation>

          <div className="copy-right border-top">
            <p>
              {filterKey(filterFooter, "footer-copyright")?.map(
                (item) => item.Value,
              )}
            </p>
          </div>
        </div>
      )}
    </>
  );
};

export default ContactUs;
